import { Link } from 'react-router-dom';

export default function RsvpClosedPage() {
  return (
    <div data-testid="rsvp-closed-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <div>
            <p className="eyebrow text-olive mb-4">RSVP</p>
            <h1 className="page-title">RSVP isn&rsquo;t open yet</h1>
          </div>
        </div>
      </header>

      <section className="py-16 md:py-24">
        <div className="max-w-2xl mx-auto px-6 md:px-12 text-center">
          <p className="text-xl md:text-2xl leading-relaxed text-forest/75">
            We&rsquo;ll add online RSVP instructions here when formal invitations
            are sent. There&rsquo;s nothing you need to do right now.
          </p>
          <Link to="/" className="btn-outline mt-9">
            Return Home
          </Link>
        </div>
      </section>
    </div>
  );
}
